import React from 'react';
import { createRoot } from 'react-dom/client';
import { ConfigProvider } from 'antd';
import { AdminApp } from './App';
import { isConfigured } from './env';
import { NotConfiguredScreen } from './screens/GateScreens';
import { createSupabase } from './supabase';
import { adminTheme } from './theme';

const root = createRoot(document.getElementById('root')!);

if (isConfigured) {
  root.render(
    <React.StrictMode>
      <AdminApp supabase={createSupabase()} />
    </React.StrictMode>
  );
} else {
  root.render(
    <ConfigProvider theme={adminTheme}>
      <NotConfiguredScreen />
    </ConfigProvider>
  );
}
